import NotFound from "./components/NotFound";
import axios from "axios";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import StreamsPage from "./Streams/StreamsPage";
import StreamsRuns from "./Streams/StreamsRuns";
import StreamsEvents from "./Streams/StreamsEvents";
import Login from "./Login/Login";
import { useAuth } from "react-oidc-context";

const App = () => {
  const auth = useAuth();

  if (auth.isLoading) {
    return <div className="streamPage-loading" style={{ marginTop: '10px', marginLeft: '10px' }}>
      <div className="spinner"></div>
      Loading...
    </div>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${auth.user.id_token}`; // Set Authorization header for all axios requests
    return (
      <Router>
        <Routes>
          <Route path="/" element={<StreamsPage />} />
          <Route
            path="/stream-runs/:streamId/:period"
            element={<StreamsRuns />}
          />
          <Route path="/stream-events/:RunId" element={<StreamsEvents />} />
          {/* 404 route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    );
  }

  return <Login />;
};

export default App;
